import { Box, Paper, Theme, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import useTranslations from "containers/hooks/useLanguageHook";
import { DataPoint } from "fileParsing/types";

// Component-specific props.
type ComponentProps = {
  data: DataPoint;
  private: boolean;
  index: number;
  linearLayout: boolean;
};

// const PrettySlider = styled(Slider)(() => ({
//   '& .MuiSlider-track': {
//     background: 'linear-gradient(90deg, rgb(79, 157, 223) 0px, rgb(244, 188, 33) 150px, rgb(176, 6, 7) 300px)',
//     height: 8,
//     borderRadius: 4,
//     border: '0px solid currentColor',
//   },
//   '& .MuiSlider-thumb': {
//     height: 24,
//     width: 24,
//     background: 'grey',
//     //border: '2px solid currentColor',
//     '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
//       boxShadow: 'inherit',
//     },
//   },
//   '& .MuiSlider-mark': {
//     backgroundColor: '#333',
//     height: 12,
//     width: 1,
//     marginTop: -3,
//   },
//   '& .MuiSlider-valueLabel': {
//     left: 'calc(-50% + 4px)',
//   },
//   '& .MuiSlider-rail': {
//     background: 'grey',
//     height: 8,
//     opacity: 0.8,
//     borderRadius: 4,
//   },
//   marginBottom: '14px'
// }));

// const marks = [
//   {
//     value: 0,
//     label: 'Not Very Sensitive',
//   },
//   {
//     value: 100,
//     label: 'Sensitive',
//   },
// ];

const Item = styled(Paper)(({ theme }: { theme: Theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  borderRadius: "15px 15px 5px 5px",
  color: theme.palette.text.secondary,
}));

function DetailItems(props: ComponentProps) {
  const theme = useTheme();
  const { t } = useTranslations();
  const color = theme.palette.categories[props.data.category];
  const item = props.data;
  return (
    <Item
      theme={theme}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          background: color.main,
          color: theme.palette.common.black,
          alignItems: "center",
          p: theme.spacing(0.5),
          borderRadius: "15px 15px 0px 0px",
          pl: theme.spacing(1),
        }}
      >
        {/* <Node color={theme.palette.common.black} size={20} margin={10} /> */}
        <Box sx={{ alignItems: "flex-start" }}>
          <Typography sx={{ fontSize: "1.2rem", fontWeight: 600 }}>{t.Categories[item.category]}</Typography>
          <Typography>
            {item.subcategory}
            <br />
            {item.date.toLocaleString()}
          </Typography>
        </Box>
      </Box>
      <Typography
        sx={{
          padding: theme.spacing(1),
          color: props.private ? "transparent" : undefined,
          textShadow: props.private ? "0 0 5px rgb(255,255,255,0.5)" : "",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          height: "100%",
          maxHeight: props.linearLayout ? null : "16em",
          minHeight: 0,
          overflowY: "auto",
          flexShrink: 1,
          flexGrow: 0,
        }}
      >
        {item.text}
      </Typography>
    </Item>
  );
}

export default DetailItems;
